/* eslint-disable require-jsdoc */
import React from 'react';
import PropTypes from 'prop-types';
import {isValid} from '../../utils/validate';
import { debug } from '../../config';


const Day = (props) => {
  // console.log('props.defaultDayValue', props.defaultDayValue);

  const timeFrame = (props) => {
    if (isValid(props.defaultDayValue)) {
      const date1 = new Date();
      const date2 = new Date(props.defaultDayValue);
      const Difference_In_Time = date2.getTime() - date1.getTime();
      const Difference_In_Days = (Difference_In_Time / (1000 * 3600 * 24))+1;
      debug && console.log('difference in days', Difference_In_Days, date1, date2);
      let timeFrame;
      if (Difference_In_Days<=1 ) {
        timeFrame = 'day';
        return timeFrame;
      }
      if (Difference_In_Days<=7 && Difference_In_Days>1 ) {
        timeFrame = 'week';
        return timeFrame;
      }
      if (Difference_In_Days<=15 && Difference_In_Days>7 ) {
        timeFrame = 'two_week'
        return timeFrame;
      } 
      if (Difference_In_Days<32&& Difference_In_Days>15 ) {
        timeFrame = 'month'
        return timeFrame;
      }    
    }
  };


  return (

    <div className="hearby-carousel-controls-item hearby-day-sort">
      <select
        name="day"
        className="hearby-cc-select-menu hearby-timeframe"
        onChange={props.change}
        defaultValue={isValid(props.defaultDayValue) ?
          timeFrame(props) : 'month'}
      >
        <option value="day">1 day</option>
        <option value="week">7 days</option>
        <option value="two_week">14 days</option>
        <option value="month">month</option>
      </select>
      {/* {console.log('day props.defaultDayValue', props.defaultDayValue)} */}
    </div>
  );
};

Day.propTypes = {
  change: PropTypes.func.isRequired,
  defaultDayValue: PropTypes.string.isRequired,
};

export default Day;
